import { FC, useEffect } from "react";
import { css, styled } from "styled-components";
import AccountIcon from "./Icons/AccountIcon";
import { Cart, MapPin } from "@fenderdigital/ui/Icons";
import { colors, font } from "../lib/sharedStyles";

interface SystemNavItem {
  url: string;
  label: string;
  Icon?: any;
}

const systemNavItems = {
  fender: [
    {
      url: '/account/login',
      label: 'My Account',
    },
    {
      url: '/pages/dealer-locator',
      label: 'Find a Dealer',
    },
    {
      url: '/cart',
      label: 'Your Cart',
    }
  ],  
  jackson: [
    {
      url: '/account/login',
      label: 'Sign In',
      Icon: AccountIcon
    },
    {
      url: '/pages/dealer-locator',
      label: 'Find a Dealer',
      Icon: MapPin
    },
    {
      url: '/cart',
      label: 'Your Cart',
      Icon: Cart
    }
  ]
};

const FenderStyles = css`
  padding: 0 32px 48px;

  a {
    padding: 5px 0;
    text-decoration: none;
    ${font('Instrument Sans', 400, '14px', '22px', '0.14px')};
    color: ${colors.fender.primaryDark};
  }
`;

const JacksonStyles = css`
  display: flex;
  flex-direction: column;
  padding: 12px 0;
  margin: 12px 0 8px;
  border-top: 1px solid #353535;
  border-bottom: 1px solid #353535;
  
  a {
    display: flex;
    align-items: center;
    ${font('Palanquin', 500, '16px', 'normal', '0.0225rem')}
    text-decoration: none;
    color: #fff;
    padding: 12px 0;

    span {
      width: 44px;
      display: flex;
      justify-content: center;
      margin-right: 16px;
    }
  }
`;

const Container = styled.div<{ $brand: string; }>`
  ${({ $brand }) => $brand == 'fender' && FenderStyles}
  ${({ $brand }) => $brand == 'jackson' && JacksonStyles};
`;

interface Props {
  brand: string;
}

const MobileSystemNav: FC<Props> = ({ brand }) => {
  // @ts-ignore
  const items: SystemNavItem[] = systemNavItems[brand];

  // Replace the default Shopify account login link with Fender Connect.
  useEffect(() => {
    if (brand == 'fender') {
      const shopifyAccountLink = document.getElementById('account-link') as HTMLAnchorElement;
      if (shopifyAccountLink && shopifyAccountLink.href) {
        items[0].url = shopifyAccountLink.href;
      }
    }
  }, []);

  return (
    <Container $brand={brand}>
      {items.map(({url, label, Icon}) => (
        <li key={`${url}-${label}`}>
          <a href={url}>
            {(Icon) && <span><Icon fill="#fff" /></span>}
            {label}
          </a>
        </li>
      ))}
    </Container>
  );
}

export default MobileSystemNav;